import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';
import Badge from 'components/common/Badge';
import useDoctorGuide from 'hooks/communication/useDoctorGuide';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useDoctorGuideList from 'hooks/communication/useDoctorGuideList';

const PAGE_ROW_CNT = 16;
export default function DrGuideNavButton(props) {
  const {
    triggered,
    onTrigger,
  } = useNavAction('DrGuide', props);

  const doctor_info = Recoil.useRecoilValue(AppStore.assets.doctor_info);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  const {
    dr_id,
  } = doctor_info || {};

  const [guide, setGuide] = React.useState({});
  const reload = Recoil.useRecoilValue(AppStore.assets.guide_reload);
  const guide_list = Recoil.useRecoilValue(AppStore.assets.guide_list);
  const {
    requestDoctorGuide,
  } = useDoctorGuide();
  React.useEffect(() => {
    if (!dr_id) return;
    if (!patient_no) return;
    if (guide_list.length && guide_list[0].send_yn === 'Y') {
      setGuide(() => ({}));
      return;
    }
    requestDoctorGuide({
      dr_id,
      patient_no,
      new_flag_yn: 'N',
    }, (success, data, parameters) => {
      if (success) {
        setGuide(() => data);
      }
    });
    // }, [dr_id, guide_list, patient_no, reload, requestDoctorGuide]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guide_list]);

  const {
    requestDoctorGuideList,
  } = useDoctorGuideList();

    const [list, setList] = Recoil.useRecoilState(AppStore.assets.guide_list);

  React.useEffect(() => {
    if (!dr_id) return;
    if (!patient_no) return;
    requestDoctorGuideList({
      dr_id,
      patient_no,
      page_row_cnt: PAGE_ROW_CNT,
      page_no: 1,
    }, (success, data, parameters) => {
      if (success) {
        setList(() => data.list);
      } else {
        setList(() => []);
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dr_id, patient_no]);

  const hasNew = React.useMemo(() => {
    const {
      draft,
    } = guide || {};
    const {
      active_guide,
      meal_guide,
      insulin_guide,
    } = draft || {};
    return 0 < (active_guide || '').length || 0 < (meal_guide || '').length || 0 < (insulin_guide || '').length;
  }, [guide]);

  return (
    <FocusableButton {...ex(['NavButton', 'DrGuideNavButton', { triggered }], props)} {...{ onClick: onTrigger() }}>
      <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_76_964)">
          <path d="M8 24C7.45 24 6.97917 23.8042 6.5875 23.4125C6.19583 23.0208 6 22.55 6 22V10C6 9.45 6.19583 8.97917 6.5875 8.5875C6.97917 8.19583 7.45 8 8 8H24C24.55 8 25.0208 8.19583 25.4125 8.5875C25.8042 8.97917 26 9.45 26 10V22C26 22.55 25.8042 23.0208 25.4125 23.4125C25.0208 23.8042 24.55 24 24 24H8ZM8 22H24V10H8V22ZM15 21H17L17.3 19.5C17.5 19.4167 17.6875 19.3292 17.8625 19.2375C18.0375 19.1458 18.2167 19.0333 18.4 18.9L19.85 19.35L20.85 17.65L19.7 16.65C19.7333 16.4333 19.75 16.2167 19.75 16C19.75 15.7833 19.7333 15.5667 19.7 15.35L20.85 14.35L19.85 12.65L18.4 13.1C18.2167 12.9667 18.0375 12.8542 17.8625 12.7625C17.6875 12.6708 17.5 12.5833 17.3 12.5L17 11H15L14.7 12.5C14.5 12.5833 14.3125 12.6708 14.1375 12.7625C13.9625 12.8542 13.7833 12.9667 13.6 13.1L12.15 12.65L11.15 14.35L12.3 15.35C12.2667 15.5667 12.25 15.7833 12.25 16C12.25 16.2167 12.2667 16.4333 12.3 16.65L11.15 17.65L12.15 19.35L13.6 18.9C13.7833 19.0333 13.9625 19.1458 14.1375 19.2375C14.3125 19.3292 14.5 19.4167 14.7 19.5L15 21ZM16 18C15.45 18 14.9792 17.8042 14.5875 17.4125C14.1958 17.0208 14 16.55 14 16C14 15.45 14.1958 14.9792 14.5875 14.5875C14.9792 14.1958 15.45 14 16 14C16.55 14 17.0208 14.1958 17.4125 14.5875C17.8042 14.9792 18 15.45 18 16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18Z" fill="#B7B7B7" />
        </g>
        <defs>
          <clipPath id="clip0_76_964">
            <rect width={24} height={24} fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
      <div>
        {T('Dr. Guide')}
        {hasNew && (<Badge {...{ count: 'N' }} />)}
      </div>
    </FocusableButton>
  );
}
